"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_content_loader_1 = __importDefault(require("react-content-loader"));
const RectLoader = (props) => {
    return (react_1.default.createElement(react_content_loader_1.default, { viewBox: `0 0 ${props.width} ${props.height}`, backgroundColor: "#EAF0FD", foregroundColor: "#ffffff" },
        react_1.default.createElement("rect", { x: "0", y: "0", rx: props.radius, ry: props.radius, width: props.width, height: props.height })));
};
exports.default = RectLoader;
